import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=53bc6525&scoped=true&"
import script from "./offline.vue?vue&type=script&lang=js&"
export * from "./offline.vue?vue&type=script&lang=js&"
import style0 from "./offline.vue?vue&type=style&index=0&id=53bc6525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc6525",
  null
  
)

export default component.exports